import {
  createSeatingReservation as publicCreateSeatingReservation,
  getSeatingReservation as publicGetSeatingReservation,
  querySeatingReservations as publicQuerySeatingReservations,
  typedQuerySeatingReservations as publicTypedQuerySeatingReservations,
  deleteSeatingReservation as publicDeleteSeatingReservation,
  getSeatingCategorySummaryByExternalId as publicGetSeatingCategorySummaryByExternalId,
  getSeatingReservationSummaryByExternalId as publicGetSeatingReservationSummaryByExternalId,
} from './seating-v1-seating-reservation-seating-reservation.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  ReservationsQueryBuilder,
  SeatingReservationQuery,
  typedQuerySeatingReservations as universalTypedQuerySeatingReservations,
} from './seating-v1-seating-reservation-seating-reservation.universal.js';
import { onSeatingReservationCreated as publicOnSeatingReservationCreated } from './seating-v1-seating-reservation-seating-reservation.public.js';
import { onSeatingReservationDeleted as publicOnSeatingReservationDeleted } from './seating-v1-seating-reservation-seating-reservation.public.js';

function customQuerySeatingReservations(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQuerySeatingReservations(httpClient)(),
    typedQueryFunction: (query: SeatingReservationQuery) =>
      publicTypedQuerySeatingReservations(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): ReservationsQueryBuilder;
  function overloadedQuery(
    query: SeatingReservationQuery
  ): ReturnType<typeof universalTypedQuerySeatingReservations>;
  function overloadedQuery(query?: SeatingReservationQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createSeatingReservation: MaybeContext<
  BuildRESTFunction<typeof publicCreateSeatingReservation> &
    typeof publicCreateSeatingReservation
> = /*#__PURE__*/ createRESTModule(publicCreateSeatingReservation);
export const getSeatingReservation: MaybeContext<
  BuildRESTFunction<typeof publicGetSeatingReservation> &
    typeof publicGetSeatingReservation
> = /*#__PURE__*/ createRESTModule(publicGetSeatingReservation);
export const deleteSeatingReservation: MaybeContext<
  BuildRESTFunction<typeof publicDeleteSeatingReservation> &
    typeof publicDeleteSeatingReservation
> = /*#__PURE__*/ createRESTModule(publicDeleteSeatingReservation);
export const getSeatingCategorySummaryByExternalId: MaybeContext<
  BuildRESTFunction<typeof publicGetSeatingCategorySummaryByExternalId> &
    typeof publicGetSeatingCategorySummaryByExternalId
> = /*#__PURE__*/ createRESTModule(publicGetSeatingCategorySummaryByExternalId);
export const getSeatingReservationSummaryByExternalId: MaybeContext<
  BuildRESTFunction<typeof publicGetSeatingReservationSummaryByExternalId> &
    typeof publicGetSeatingReservationSummaryByExternalId
> = /*#__PURE__*/ createRESTModule(
  publicGetSeatingReservationSummaryByExternalId
);
export const querySeatingReservations: MaybeContext<
  BuildRESTFunction<typeof customQuerySeatingReservations> &
    typeof customQuerySeatingReservations
> = /*#__PURE__*/ createRESTModule(customQuerySeatingReservations);
/** */
export const onSeatingReservationCreated: BuildEventDefinition<
  typeof publicOnSeatingReservationCreated
> &
  typeof publicOnSeatingReservationCreated = createEventModule(
  publicOnSeatingReservationCreated
);
/** */
export const onSeatingReservationDeleted: BuildEventDefinition<
  typeof publicOnSeatingReservationDeleted
> &
  typeof publicOnSeatingReservationDeleted = createEventModule(
  publicOnSeatingReservationDeleted
);

export {
  SortOrder,
  Type,
  PlaceTypeEnumType,
  ShapeTypeEnumType,
  Position,
  Icon,
  Numbering,
  WebhookIdentityType,
} from './seating-v1-seating-reservation-seating-reservation.universal.js';
export {
  SeatingReservation,
  PlaceReservation,
  SeatingPlanCategoriesSummaryUpdated,
  CategoryDetails,
  InvalidateCache,
  InvalidateCacheGetByOneOf,
  App,
  Page,
  URI,
  File,
  CustomTag,
  Pages,
  URIs,
  CreateSeatingReservationRequest,
  CreateSeatingReservationResponse,
  Places,
  UnavailablePlaces,
  ReservationErrorDetails,
  GetReservationRequest,
  GetReservationResponse,
  GetSeatingReservationRequest,
  GetSeatingReservationResponse,
  QuerySeatingReservationRequest,
  QueryV2,
  QueryV2PagingMethodOneOf,
  Sorting,
  AddressLocation,
  Paging,
  CursorPaging,
  QuerySeatingReservationResponse,
  PagingMetadataV2,
  Cursors,
  QuerySeatingReservationsRequest,
  QuerySeatingReservationsResponse,
  DeleteSeatingReservationRequest,
  DeleteSeatingReservationResponse,
  DeleteSeatingPlaceReservationRequest,
  Empty,
  CancelSeatingPlaceReservationsRequest,
  PlaceReservationDetails,
  CancelSeatingPlaceReservationsResponse,
  UpdateSeatingReservationRequest,
  UpdateSeatingReservationResponse,
  GetReservedPlacesRequest,
  GetReservedPlacesResponse,
  ListReservedPlacesRequest,
  ListReservedPlacesResponse,
  SeatReservation,
  ReservedPlace,
  PagingMetadata,
  GetSeatingCategorySummaryRequest,
  GetSeatingCategorySummaryResponse,
  GetSeatingCategorySummaryByExternalIdRequest,
  GetSeatingCategorySummaryByExternalIdResponse,
  GetSeatingReservationSummaryRequest,
  GetSeatingReservationSummaryResponse,
  SeatingPlan,
  Section,
  Element,
  Sequencing,
  Place,
  ReservationOptions,
  ElementUiProperties,
  Image,
  MultiRowProperties,
  RowElement,
  RowElementUiProperties,
  VerticalSequencing,
  Category,
  ExtendedFields,
  SeatingPlanUiProperties,
  ElementGroup,
  ElementGroupUiProperties,
  GetSeatingReservationSummaryByExternalIdRequest,
  GetSeatingReservationSummaryByExternalIdResponse,
  RegenerateSummariesRequest,
  RegenerateSummariesResponse,
  SeatingReservationsSummary,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  ListAvailablePlacesRequest,
  ListAvailablePlacesResponse,
  AvailablePlace,
  DeleteSeatingReservationByExternalIdRequest,
  DeleteSeatingReservationByExternalIdResponse,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  SeatingReservationCreatedEnvelope,
  SeatingReservationDeletedEnvelope,
  CreateSeatingReservationOptions,
  ReservationsQueryResult,
  ReservationsQueryBuilder,
  SeatingReservationQuerySpec,
} from './seating-v1-seating-reservation-seating-reservation.universal.js';
export { utils } from './seating-v1-seating-reservation-seating-reservation.universal.js';
export {
  SortOrderWithLiterals,
  TypeWithLiterals,
  PlaceTypeEnumTypeWithLiterals,
  ShapeTypeEnumTypeWithLiterals,
  PositionWithLiterals,
  IconWithLiterals,
  NumberingWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CreateSeatingReservationApplicationErrors,
  CommonQueryWithEntityContext,
  SeatingReservationQuery,
} from './seating-v1-seating-reservation-seating-reservation.universal.js';
